import { Button, ButtonGroup } from '@material-ui/core'
import { ODataParams } from '@sensenet/client-core'
import { GenericContent } from '@sensenet/default-content-types'
import { ColumnSetting } from '@sensenet/list-controls-react/src/ContentList/content-list-base-props'
import { ColDef } from 'ag-grid-community'
import React, { useState } from 'react'
import { GridKeyEnum } from '../../src/components/grid/enums/GridKey.enum'

interface GridSwitcherItem {
  icon?: JSX.Element
  name: string
  displayName: string
  schema?: string
  fieldsToDisplay: Array<ColumnSetting<GenericContent>>
  loadSettings?: ODataParams<GenericContent>
  colDef: ColDef[]
  gridKey: GridKeyEnum
}

interface GridSwitcherProps {
  config: GridSwitcherItem[]
  defaultItem: GridSwitcherItem
}

export const useGridSwitcher = ({ config, defaultItem }: GridSwitcherProps) => {
  const [activeItem, setActiveItem] = useState<GridSwitcherItem>(defaultItem)

  function renderButtons() {
    return (
      <ButtonGroup variant="contained" color="primary" aria-label="contained primary button group">
        {config.map((item) => (
          <Button
            key={item.name}
            data-test={`${item.name.replace(/\s+/g, '-').toLowerCase()}`}
            startIcon={item.icon}
            onClick={() => setActiveItem(item)}
            style={activeItem.name !== item.name ? { backgroundColor: '#929292' } : {}}>
            {item.displayName}
          </Button>
        ))}
      </ButtonGroup>
    )
  }

  return {
    activeItem,
    renderButtons,
  }
}
